import React from 'react';
import { Switch, Route } from 'react-router-dom';
// Screens
// import LiveWebinarLayout from './LiveWebinarLayout';
import LiveWebinarLecture from './LiveWebinarLecture';

const LiveWebinarStack = () => {
  return (
    <Switch>
      {/* <Route exact path="/live-webinar" component={LiveWebinarLayout} /> */}
      <Route path="/live-webinar" component={LiveWebinarLecture} />
    </Switch>
  );
};
export default LiveWebinarStack;
